import React, { useEffect, useState } from 'react';
import PageContainer from '../components/containers/PageContainer';
import Field from '../components/ui/Field';
import CustomTable from '../components/ui/CustomTable';
import { IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import StatusComp from '../components/common/StatusComp';
import api from '../config/axios';
import env from '../config/env';
import { toast } from 'react-toastify';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
const BulkOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loader, setLoader] = useState(false);
    const [filter, setFilter] = useState('All');
    const [sort, setSort] = useState('asc');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');

    useEffect(() => {
        getOrders();
    }, [page, sort, filter, limit, search]);

    const getOrders = async () => {
        setLoader(true);
        let link = '';
        if (search !== '') {
            link = `/admin/orders/bulk?page=${page}&limit=${limit}&sort=${sort}&status=${filter}&search=${search}`;
        } else {
            link = `/admin/orders/bulk?page=${page}&limit=${limit}&sort=${sort}&status=${filter}`;
        }

        await api
            .get(link)
            .then((res) => {
                setOrders(res.data.csvOrders);
                setTotalPages(res.data.totalPages);
                setTotal(res.data.total);
                setLoader(false);
            })
            .catch((err) => {
                console.log(err);
                setLoader(false);
            });
    };

    const downloadCSVZip = async (id) => {
        await api
            .get(`/admin/orders/bulk/${id}`, env.downloadConfig)
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'CSV.zip');
                document.body.appendChild(link);
                link.click();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    return (
        <PageContainer title="View CSV Bulk Orders" desc="All your CSV bulk orders at one place">
            <Typography variant="h5" sx={{ color: 'primary.main' }}>
                Bulk Orders
            </Typography>

            <Field
                sx={{ mt: 1 }}
                placeholder="Search orders using order id, name"
                onChange={(e) => {
                    setSearch(e.target.value);
                }}
            />
            <CustomTable
                sx={{ mt: 2 }}
                fields={['ORDER ID', 'USER', 'TOTAL', 'LABELTYPE', 'NO. OF ORDERS', 'STATUS', 'CREATED AT', 'ACTION']}
                dense={false}
                loading={loader}
                pagination
                count={totalPages}
                page={page}
                setPage={setPage}>
                {orders.map((order, index) => (
                    <TableRow key={order._id}>
                        <TableCell>{order._id}</TableCell>
                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {order.user?.username}
                        </TableCell>
                        <TableCell
                            sx={{
                                color: 'success.main',
                            }}>
                            ${order.price ? order.price.toFixed(2) : '0.00'}
                        </TableCell>
                        <TableCell>{order.labelType?.name}</TableCell>

                        <TableCell
                            sx={{
                                color: 'primary.main',
                            }}>
                            {order.orders.length}
                        </TableCell>
                        <TableCell>
                            <StatusComp status={order.status} />
                        </TableCell>
                        <TableCell>{new Date(order.createdAt).toLocaleString()}</TableCell>
                        <TableCell>
                            <Tooltip title="Download CSV ZIP">
                                <IconButton
                                    onClick={() => {
                                        downloadCSVZip(order._id);
                                    }}>
                                    <DownloadRoundedIcon color="primary" fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
        </PageContainer>
    );
};

export default BulkOrders;
